import { combineReducers } from "redux";
import userReducer from "./userReducer";
import schoolReducer from "./schoolReducer";
import dashboardReducer from "./dashboardReducer";
import loadingReducer from "./loadingReducer";

const rootReducer = combineReducers({
  user: userReducer,
  school: schoolReducer,
  dashboard: dashboardReducer,
  loading: loadingReducer,
});

export default rootReducer;
